import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TransactionWrapper } from '@core/models';
import { catchError, forkJoin, map, of } from 'rxjs';
import { ConnectionService } from '../services/connection.service';

export const checkoutResolver: ResolveFn<TransactionWrapper | null> = route => {
  const configurationService = inject(ConnectionService);

  configurationService.token = route.queryParams['token'];
  const transactionId = route.params['id'];
  if (!transactionId || !Number.isFinite(Number(transactionId))) {
    return of(null);
  }

  return forkJoin({
    // braintree=true: checkout now also renders the Payment Options section
    // (merged from the former /payment/:id route), so the Braintree client
    // token must be present from the first load.
    transaction: configurationService.getTransactionById(transactionId, true),
    // The client fetch is best-effort: consumers already read `.client` with
    // optional chaining, so a failure here must not fail the whole resolver
    // and take down an otherwise-valid transaction.
    client: configurationService
      .getCurrentClient()
      .pipe(catchError(() => of(undefined))),
  }).pipe(
    map(({ transaction, client }) => {
      if (!transaction.data) {
        return null;
      }
      return {
        ...transaction.data,
        client: client?.data,
      };
    }),
    catchError(() => {
      return of(null);
    })
  );
};
